import { Injectable } from '@angular/core';

import { environment } from '@env/environment';
import { AppConstants } from '@root/app.constants';
import { ServerInfoService } from '@services/server-info.service';
import { UserService } from '@services/user.service';
import { StatusService } from '@services/v2/status.service';

@Injectable({
	providedIn: 'root'
})
export class ErrorReportService {

	constructor(
		private userService: UserService,
		private serverInfoService: ServerInfoService,
		private versionService: StatusService
	) { }

	async openWebSupport(errorKey: string | null, errorMessage: string | null, errorUrl: string | null) {
		let url = AppConstants.websupportUrl;

		url += this.getSystemInfoAsQueryString();

		if (errorUrl)
			url += `&error_url=${errorUrl ?? ''}`;

		if (errorKey)
			url += `&errorKey=${errorKey ?? ''}`;

		if (errorMessage)
			url += `&errorMessage=${errorMessage ?? ''}`;

		window.open(url, '_blank');
	}

	async getSystemInfoAsQueryString() {
		let queryString = '';

		try {
			const user = await this.userService.GetUser();

			let dataserverregion = '';
			let imageurlregion = '';
			let imagecdnurlregion = '';

			try {
				dataserverregion = (await this.serverInfoService.getServerInfo())?.Region ?? '';
				imageurlregion = (await this.serverInfoService.getImageServerInfo())?.region ?? '';
				imagecdnurlregion = (await this.serverInfoService.getImageCdnServerInfo())?.region ?? '';
			}
			catch (error) {
				console.error('getServerInfo failed', error)
			}

			queryString += `&alias=${user?.Alias}`;
			queryString += `&accountnumber=${user?.CustomerNo}`;
			queryString += `&appversion=${this.versionService.getApiVersion()}`;
			queryString += `&dataserver=${environment.dataUrl}`;
			queryString += `&dataserverregion=${dataserverregion}`;
			queryString += `&imageurl=${environment.imageUrl}`;
			queryString += `&imageurlregion=${imageurlregion}`;
			queryString += `&imageurlCDN=${environment.imageCDNUrl}`;
			queryString += `&imageurlCDNregion=${imagecdnurlregion}`;
		}
		catch (error) {
			console.error(`An error occurred while trying to open web support page (${error})`);
		}

		return queryString;
	}

}
